export const initialState = {
  loading: false,
  step: 0,
  stage: 0,
  canCreateCategory: false,
  status: "home",
  response: { message: null, error: null },
  currentCategoryId: 0,
};
